import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { ServiceBagServices, ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { BaseState, GenericListEntity, BaseEntitiesResponse,  } from '@m4u-angular/base/entities/BaseEntities';
import { Component } from '@angular/core';
import { Customer } from '@dato-proxy/entities/customer.entity';
import { CustomerEndpoint } from '@dato-proxy/endpoints/customer.endpoint';
import { EnumPageDisplayModes } from '@m4u-angular/core/framework/sysenums.enum';

class State extends BaseState {
    Banks: GenericListEntity[];
}

@Component({
    providers: ServiceBagServices,
    selector: 'app-bank-details',
    templateUrl: './bank-details.component.html',
    styleUrls: ['./bank-details.component.scss']
})
export class BankDetailsComponent extends BasePageComponent<Customer, State> {

    constructor(A: ServiceBagService,
        private customerEndpoint: CustomerEndpoint) {
        super(A, 'BankDetailsComponent', Customer, State, EnumPageDisplayModes.Window);
    }

    override OnInitComponent() {
        this.Do(this.customerEndpoint.GetCurrent(), false, (response) => {
            this.Entity = response.Entity;
        })
        this.Do(this.customerEndpoint.GetBanksList(), false, (response: BaseEntitiesResponse<GenericListEntity>) => {
            this.State.Banks = response.Entities;
        });
    }

    OnSaveDetails() {
        this.Do(this.customerEndpoint.SaveBankDetails(this.Entity), true, (response) => {
            this.NotifyEntitySaved(this.Entity, Customer);
            this.NavigateBack();
        })
    }

}
